// Tiny FIFO cache for expensive per-url results (extracted frames, waveform
// peaks) so remounting the track reuses them. Oldest entry drops past `max`.
const createFifoCache = (max) => {
  const entries = new Map();
  return {
    get: (key) => entries.get(key),
    set: (key, value) => {
      entries.set(key, value);
      if (entries.size > max) entries.delete(entries.keys().next().value);
    },
  };
};

export default createFifoCache;
